import { Storage as AWStorage, StorageKey } from 'lib/amwell/client/types';

export type Storage = AWStorage;

export { StorageKey };

export type SetStoragePayload<T> = {
  [P in keyof T]: T[P];
};

export type HydratePayload<T> = SetStoragePayload<T>;

export interface RemoveStoragePayload {
  keys: (keyof Storage)[];
}

export interface ClearStoragePayload {
  opts: 'all' | 'session';
}
